module.exports = __webpack_public_path__ + "cd3184e801818a50ed5853dfd48c463a.svg";